import { User } from './../model/user.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  baseUrl = environment.baseUrl; 

  constructor(private http: HttpClient) { }

  getAll(page: any): Observable<any>{
    const url = `${this.baseUrl}usuarios`;
    return this.http.get<User[]>(url, page);
  }

  listarService(): Observable<User[]>{
    const url = `${this.baseUrl}usuarios`;
    return this.http.get<User[]>(url);
  }

  listarServiceUsuario(id: any): Observable<any>{
    const url = `${this.baseUrl}usuarios/listarTodos`;
    let params = new HttpParams().set('cliente', id);
    return this.http.get<any>(url, {params: params});
  }

  listarPorIdService(id: any): Observable<User> {
    const url = `${this.baseUrl}usuarios/${id}`;
    return this.http.get<User>(url);
  }

  cadastrarService(user: User): Observable<User>{
    const url = `${this.baseUrl}register`;
    return this.http.post<User>(url, user);
  }

  atualizarService(user: User): Observable<User>{
    const url = `${this.baseUrl}usuarios/atualizar/${user.sr_id}`;
    return this.http.put<User>(url, user);
  }

  atualizarSenha(senha: any, id: any){
    const url = `${this.baseUrl}usuarios/atualizarSenha/${id}`;
    return this.http.put(url, senha);
  }

  statusService(user: User): Observable<any>{
    var status = new Object();
    status = {'status': user.bl_status}
    const url = `${this.baseUrl}usuarios/status/${user.sr_id}`;
    return this.http.put<any>(url, status)
  }

  public confirmAlert(usuario: any): void {
    Swal.fire({
      title: 'Desativar usuário?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        usuario.bl_status = 0;
        this.statusService(usuario).subscribe((resp) => {})
      }
    })
  }

  public desativarAlert(usuario: any): void {
    Swal.fire({
      title: 'Ativar usuário?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar!'
    }).then((result) => {
      if (result.isConfirmed) {
        usuario.bl_status = 1;
        this.statusService(usuario).subscribe((resp) => {})
      }
    })
  }

  public listarUsuariosAgrupamentos(){
    const url = `${this.baseUrl}agrupamentos/usuarios`;
    return this.http.get<User>(url);
  }
}
